"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineLoading = exports.fadeOut = exports.fadeIn = exports.animateZoom = void 0;
var _styledComponents = require("styled-components");
const fadeIn = (0, _styledComponents.keyframes)`
    from {opacity: 0;}
    to {opacity: 1;}
`;
exports.fadeIn = fadeIn;
const fadeOut = (0, _styledComponents.keyframes)`
    from {opacity: 1;}
    to {opacity: 0;}
`;
exports.fadeOut = fadeOut;
const animateZoom = (0, _styledComponents.keyframes)`
    from { transform: scale(0.85); }
    to {
        transform: scale(1);
        transform: translateZ(0);
        fliter: blur(0);
    }
`;
exports.animateZoom = animateZoom;
const lineLoading = (0, _styledComponents.keyframes)`
    from {
        left: -200px;
        width: 30%;
    }
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
`;
exports.lineLoading = lineLoading;